import React from 'react'
import styles from './ContactInduction.module.css'

export default function ContactInduction() {
    return (
        <section id='contact_induction' className={styles.contactInduction}>
            <h1>
                まずは気軽に
                <span className={styles.br}>お問い合わせください</span>
            </h1>
            <a className={styles.cta} href='#form'>
                問い合わせる
            </a>
        </section>
    )
}
